/** QFPay hosted checkout `lang` values. */
export type QfpayLang = 'en' | 'zh-hk' | 'zh-cn';

/** Map i18n / browser locale to QFPay checkout language. */
export function toQfpayLang(lang: string | null | undefined): QfpayLang | undefined {
  const raw = lang?.trim();
  if (!raw) return undefined;

  const key = raw.toLowerCase().replace(/_/g, '-');
  const aliases: Record<string, QfpayLang> = {
    en: 'en',
    english: 'en',
    'zh-hk': 'zh-hk',
    'zh-hant': 'zh-hk',
    'zh-cn': 'zh-cn',
    'zh-hans': 'zh-cn',
  };

  return aliases[key];
}
